import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { getLatestDiagnosisReport } from '@/services/get-latest-diagnosis-report'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export const GET_LATEST_DIAGNOSIS_REPORT_QUERY = 'get-latest-diagnosis-report'

interface UseGetLatestDiagnosisReportOptions {
  onError?: () => void
  enabled?: boolean
}

export function getLatestDiagnosisReportQueryKey(diagnosisId: string) {
  return [GET_LATEST_DIAGNOSIS_REPORT_QUERY, diagnosisId]
}

export function useGetLatestDiagnosisReport(
  treatment: Treatment,
  culture: Culture,
  diagnosisId: string,
  { enabled }: UseGetLatestDiagnosisReportOptions = {},
) {
  const query = useQuery({
    queryKey: getLatestDiagnosisReportQueryKey(diagnosisId),
    queryFn: ({ signal }) =>
      getLatestDiagnosisReport(treatment, culture, diagnosisId, { signal }),
    onError: (e: Error) => {
      toast.error(
        `Não foi possível buscar o relatório do diagnóstico: ${e.message}`, // TODO: improve this error message
      )
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return query
}
